import * as types from 'legacy/src/constants/types';
import { combineReducers } from 'redux';

const data = (state = [], action) => {
  switch (action.type) {
    case types.NAV_DATA:
      return action.data;
    default:
      return state;
  }
};

const loading = (state = true, action) => {
  switch (action.type) {
    case types.NAV_LOADING:
      return action.loading;
    default:
      return state;
  }
};

const prevLocation = (state = '', action) => {
  if (action.type === types.LOCATION_CHANGE) {
    return action.location;
  }
  return state;
};

const nav = combineReducers({
  data,
  loading,
  prevLocation,
});

export default nav;
